import Navbar from "../general/navbar";
import Vision from "../about/vision";
import Montessori from "../about/montessori";
import Team from "../about/team";
import Place from "../about/place";
import ImageCarousel from "../general/imageCarousel";
import Footer from "../general/footer";

export default function IndexPage() {
  return (
    <div className="about-page">
      <Navbar />
      <Vision />
      <Montessori />
      <Team />
      <Place />
      <ImageCarousel />
      <Footer />
    </div>
  );
}
